import React, { PureComponent } from "react";
import Table from "js/components/Shared/Tabla";
import advancedFilter from "js/components/TablaCatalogoCodigos/advancedFilter.js";
import AppQraphQL from "js/graphql/resolvers/catalogoCodigos.resolver";
import { numberWithCommas } from "js/utils";
import {
  viewAction,
  editAction,
  showSucursalAction
} from "js/components/Shared/Tabla/ActionCells";
import { USER_ROLES as Roles } from "js/models/User";
import { Estado } from "js/components/Shared/Tabla/TableCells";
import capitalize from "lodash/capitalize";
import AppQraphQLImport from "js/graphql/resolvers/importar.resolver";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import ListIcon from "@material-ui/icons/ListAlt";

const defaultHeader = (id, btnsNextTitle) => {
  return {
    title: "Catálogo Códigos",
    btnsNextTitle,
    new: {
      title: "Nuevo",
      perms: [Roles.CATALOGO_CODIGO_W]
    },
    export: {
      path: "beneficios",
      perms: [Roles.CATALOGO_CODIGO_R],
      tooltip: "Exportar catálogo"
    },
    import: {
      action: AppQraphQLImport.queries.importCatalogoCodigos,
      perms: [Roles.CATALOGO_CODIGO_W],
      tooltip: "Importar catálogo",
      model: "Modelo_Catalogo_Codigos.csv",
      modelTooltip: "Modelo de importación de catálogo",
      variables: {
        idPrograma: id
      }
    },
    others: [
      {
        action: AppQraphQLImport.queries.importCatalogoCodigosSegmentos,
        perms: [Roles.CATALOGO_CODIGO_W],
        model: "Modelo_Catalogo_Codigos_Segmentos.csv",
        tooltip: "Importar segmentos de catálogo",
        type: "import",
        variables: {
          idPrograma: parseInt(id, 10)
        },
        id: "upload-segmentos"
      },
      {
        path: "beneficios/segmentos",
        perms: [Roles.CATALOGO_CODIGO_R],
        type: "export",
        tooltip: "Exportar segmentos de catálogo"
      },
      {
        action: AppQraphQLImport.queries.importCatalogoCodigosUbicaciones,
        perms: [Roles.CATALOGO_CODIGO_W],
        model: "Modelo_Catalogo_Codigos_Ubicaciones.csv",
        tooltip: "Importar ubicaciones de catálogo",
        type: "import",
        variables: {
          idPrograma: parseInt(id, 10)
        },
        id: "upload-ubicacion"
      },
      {
        path: "beneficios/ubicaciones",
        perms: [Roles.CATALOGO_CODIGO_R],
        type: "export",
        tooltip: "Exportar ubicaciones de catálogo"
      },
      {
        action: AppQraphQLImport.queries.importCatalogoCodigosRubros,
        perms: [Roles.CATALOGO_CODIGO_W],
        model: "Modelo_Catalogo_Codigos_Categorías.csv",
        tooltip: "Importar categorías de catálogo",
        type: "import",
        variables: {
          idPrograma: parseInt(id, 10)
        },
        id: "upload-categoria"
      },
      {
        path: "beneficios/categorias",
        perms: [Roles.CATALOGO_CODIGO_R],
        type: "export",
        tooltip: "Exportar categorias de catálogo"
      }
    ]
  };
};
const columnData = [
  { id: "idBeneficio", label: "ID", isNumeric: true },
  { id: "nombre", label: "Nombre" },
  { id: "idTipo_tipo", label: "Tipo" },
  {
    id: "segmentos",
    label: "Segmento",
    type: "array",
    field: "nombre",
    removeSort: true
  },
  {
    id: "rubros",
    label: "Rubro",
    type: "array",
    field: "descripcion",
    removeSort: true
  },
  {
    id: "paises",
    label: "Pais",
    type: "array",
    field: "descripcion",
    removeSort: true
  },
  { id: "emailProveedor", label: "Email Proveedor" },
  {
    id: "stock",
    isNumeric: true,
    label: "Stock",
    type: "custom",
    parser: (stock, beneficio) => {
      if (beneficio.stockInfinito) {
        return <span style={{ fontSize: "1.75rem" }}>∞</span>;
      } else {
        return numberWithCommas(stock);
      }
    }
  },
  { id: "fecha", label: "Fecha Vencimiento", type: "date" },
  {
    id: "estado",
    label: "Estado",
    type: "custom",
    parser: estado => <Estado estado={capitalize(estado)} />
  },
  { id: "actions", label: "Acciones" }
];

const defaultSort = { order: "asc", orderBy: "nombre" };

class Tabla extends PureComponent {
  render() {
    const {
      match: {
        params: { id }
      }
    } = this.props;

    const view = params => ({
      ...viewAction({
        ...params,
        history: this.props.history,
        perms: [Roles.CATALOGO_CODIGO_R]
      })
    });
    const edit = params => ({
      ...editAction({
        ...params,
        history: this.props.history,
        perms: [Roles.CATALOGO_CODIGO_W]
      })
    });
    const sucursal = params => ({
      ...showSucursalAction({
        ...params,
        history: this.props.history,
        perms: [Roles.SOLICITUD_CATALOGO_CODIGO_R]
      }),
      onclick: () =>
        this.props.history.push(
          `${window.location.pathname}/${params.itemId}/sucursales-beneficio`
        )
    });

    const btnsNextTitle = [];
    btnsNextTitle.push({
      btn: (
        <Tooltip title="Solicitudes">
          <IconButton
            color="primary"
            onClick={() =>
              this.props.history.push(
                `/admin/programa/${id}/solicitudes-catalogo-codigos`
              )
            }
          >
            <ListIcon />
          </IconButton>
        </Tooltip>
      ),
      perms: [Roles.SOLICITUD_CATALOGO_CODIGO_R]
    });

    return (
      <Table
        storage={"FiltroCatalogoCodigosAdmin"}
        query={AppQraphQL.queries.getPaginaCatalogoCodigos}
        defaultHeader={defaultHeader(id, btnsNextTitle)}
        advancedFilter={advancedFilter}
        sort={defaultSort}
        columnData={columnData}
        getTipo={data => data.getCatalogoCodigos}
        actionsCustom={[view, edit, sucursal]}
        pathId={"idBeneficio"}
      />
    );
  }
}

export default Tabla;
